import {
  ClearButtons,
  FormatButtons,
  LevelSelect,
  LinkButtons,
  ListButtons,
  RichTextInput,
  RichTextInputProps,
  RichTextInputToolbar,
} from "ra-input-rich-text";

export default function RichTextInputWithoutCustomStyles(props: RichTextInputProps) {
  return (
    <RichTextInput
      fullWidth
      toolbar={
        <RichTextInputToolbar>
          <LevelSelect />
          <FormatButtons />
          <LinkButtons />
          <ListButtons />
          <ClearButtons />
        </RichTextInputToolbar>
      }
      {...props}
    />
  );
}
